// extracted by mini-css-extract-plugin
export default {"container":"policy_container__ptlBi"};